import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from "../../environments/environment";
import {RequiredRoadDataModel} from "../models/required-terminal-road-data-overview.model";

@Injectable()
export class TerminalRoadDataConfigurationDataSource {

  constructor(
    private http: HttpClient
  ) { }

  /**
   * Asynchronously loads a list of all known countries and states with a flag for each telling whether this state
   * data is required for the given {@link terminalId} or not.
   * @param terminalId The terminal for which the required road data should be loaded.
   */
  getRequiredRoadDataOverview(terminalId: number): Observable<RequiredRoadDataModel> {
    return this.http.get<RequiredRoadDataModel>(environment.backendApi + 'api/RequiredRoadData/Terminal/' + terminalId);
  }

  /**
   * Asynchronously updates the required road data for the given {@link terminalId} and {@link requiredStates}.
   * @param terminalId The terminal for which the required road data should be updated.
   * @param requiredStates The list of country/state code which and only which should be flagged as required.
   */
  updateRequiredTerminalRoadData(terminalId: number, requiredStates: CountryStateReference[]) : Observable<void> {
    return this.http.post<void>(
      environment.backendApi + 'api/RequiredRoadData/Terminal/' + terminalId,
      requiredStates
    );
  }
}

/**
 * A WS API model that maps to the backend type 'CountryStateReferenceModel'.
 */
export class CountryStateReference {
  countryCode: string
  stateCode: string

  constructor(countryCode: string, stateCode: string) {
    this.countryCode = countryCode;
    this.stateCode = stateCode;
  }
}
